/*
 * Product-page gift block.
 *
 * Two jobs:
 *  1. Open/close the panel. The To/From/Message fields are disabled while it's
 *     closed, so a plain purchase never carries empty gift properties.
 *  2. When one or more add-ons are ticked, post the piece and its add-ons to
 *     the cart in a single request, then hand the result to Dawn's cart drawer
 *     exactly as its own product form would. With nothing ticked, Dawn's
 *     normal add-to-cart runs untouched.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-pfb-gift]').forEach(function (root) {
    var toggle = root.querySelector('[data-pfb-gift-toggle]');
    var panel = root.querySelector('[data-pfb-gift-panel]');
    var inputs = root.querySelectorAll('[data-pfb-gift-input]');
    var countSrc = root.querySelector('[data-pfb-gift-count-source]');
    var countEl = root.querySelector('[data-pfb-gift-count]');
    var form = document.getElementById(root.dataset.formId);

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      root.classList.toggle('pfb-gift--open', open);
      inputs.forEach(function (i) { i.disabled = !open; });
      if (!open) {
        root.querySelectorAll('[data-pfb-addon]').forEach(function (c) { c.checked = false; });
      }
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    if (countSrc && countEl) {
      countSrc.addEventListener('input', function () { countEl.textContent = countSrc.value.length; });
    }

    if (!form) return;

    // Capture phase, so this runs before Dawn's product-form handler and can
    // stand in for it only when add-ons are involved.
    form.addEventListener('submit', function (event) {
      // A blank "Gift for" would otherwise reach the order as an empty
      // property. Switch blank fields off for this one submission only.
      if (!panel.hidden) {
        var blanks = Array.prototype.filter.call(inputs, function (i) {
          return !i.disabled && !i.value.trim();
        });
        blanks.forEach(function (i) { i.disabled = true; });
        setTimeout(function () { blanks.forEach(function (i) { i.disabled = false; }); }, 0);
      }

      var ticked = Array.prototype.filter.call(
        root.querySelectorAll('[data-pfb-addon]'),
        function (c) { return c.checked; }
      );
      if (!ticked.length || panel.hidden) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var submitBtn = form.querySelector('[type="submit"]');
      var errorEl = form.closest('product-form') &&
        form.closest('product-form').querySelector('.product-form__error-message');
      if (submitBtn) { submitBtn.setAttribute('aria-disabled', 'true'); submitBtn.classList.add('loading'); }

      var data = new FormData(form);
      var props = {};
      data.forEach(function (value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(value).trim()) props[m[1]] = String(value).trim();
      });

      var productTitle = (document.querySelector('.product__title h1') || {}).textContent || 'your piece';
      var items = [{
        id: Number(data.get('id')),
        quantity: Number(data.get('quantity')) || 1,
        properties: props,
      }].concat(ticked.map(function (c) {
        return { id: Number(c.value), quantity: 1, properties: { 'For': productTitle.trim() } };
      }));

      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
          if (cart && typeof cart.renderContents === 'function') {
            res.json.id = items[0].id;
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res.json);
            if (window.publish && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pfb-gift', cartData: res.json });
            }
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = err.message;
            if (errorEl.parentElement) errorEl.parentElement.hidden = false;
          }
        })
        .finally(function () {
          if (submitBtn) { submitBtn.removeAttribute('aria-disabled'); submitBtn.classList.remove('loading'); }
        });
    }, true);
  });
})();
